import {ChangeEvent, KeyboardEvent, useCallback, useEffect, useRef, useState} from "react";

/*
  Backend call
 */
export default function AddItem(
    {
        addToList,
        startingText,
        forceFocus,
        disabled,
    } : {
        addToList: (text: string) => void,
        startingText?: string | null
        forceFocus?: boolean | null
        disabled: boolean
    }
) {

    const inputRef = useRef<HTMLInputElement>(null)
    const [text, setText] = useState(startingText || "");

    useEffect(() => {
        // We only focus when it is possible =)
        if (navigator.userAgent.search(/iphone/i) === -1 || forceFocus) {
            inputRef.current?.focus();
        }
    }, [forceFocus]);

    const addItem = useCallback(() => {
        if (text.trim().length > 1) { // We don't want to add anything to the list that is less than 2 charaters
            addToList(text.trim());
            setText("");
        }
    }, [addToList, text]);

    const handleKeyUp = (event : KeyboardEvent) => {
        if (event.key === 'Enter') {
            addItem();
        }
    }

    const handleChange = (event : ChangeEvent<HTMLInputElement>) => {
        setText(event.target.value);
    }

    const handlePasteData = useCallback((pastedData: string) => {
        if (pastedData.trim().split("\n").length > 1) {
            // We have a multiline input =)
            for (let line of pastedData.trim().split("\n")) {
                if (line.startsWith("▢")) {
                    line = line.substring(1);
                }
                if (line.startsWith("☐")) {
                    line = line.substring(1);
                }

                if (line.trim().length !== 0) {
                    addToList(line.trim());
                }
            }

            return true
        } else {
            return false
        }
    }, [addToList])

    useEffect(() => {
        if (inputRef.current == null) return

        const handler = (event: any) => {
            if (
                event instanceof ClipboardEvent
                && event.clipboardData
            ) {
                if (handlePasteData(event.clipboardData.getData("text/plain"))) {
                    event.preventDefault()
                }
            }

            if (event.detail?.fakePasteData) {
                if (handlePasteData(event.detail?.fakePasteData)) {
                    event.preventDefault()
                }
            }
        }

        const current = inputRef.current
        current.addEventListener('paste', handler)

        return () => {
            current.removeEventListener('paste', handler)
        }
    }, [inputRef, handlePasteData])

    const handleOnClick = () => {
        addItem();
        inputRef.current?.focus();
    };

    return (
        <>
            <label className={"additem"}>
                <input enterKeyHint={"go"} name={"itemName"} className={text.trim().length > 0 ? "hasText" : ""} disabled={disabled} ref={inputRef} type={"text"} onKeyUp={handleKeyUp} value={text} onChange={handleChange} />
                <button disabled={disabled} onClick={handleOnClick}>Lägg till</button>
            </label>
        </>
    );
}
